import { api } from './client';
import type { Client, Visit } from './types';

export function fetchClients() {
  return api<Client[]>('/clients');
}

export function crearCliente(payload: Record<string, unknown>) {
  return api<Client>('/clients', { method: 'POST', body: JSON.stringify(payload) });
}

export function editarCliente(id: string, data: Record<string, unknown>) {
  return api<Client>(`/clients/${id}`, { method: 'PATCH', body: JSON.stringify(data) });
}

export function eliminarCliente(id: string) {
  return api(`/clients/${id}`, { method: 'DELETE' });
}

export function fetchHistorialCliente(id: string) {
  return api<Visit[]>(`/clients/${id}/visitas`);
}
